import DashboardHeader from "../../Components/DashboardHeader/DashboardHeader";
import cluppyImg from "../../Assets/PNG/Clupp_ThumbsUp.png";
import { useAgentAuth } from "../../AuthAgentContext";
import { Redirect } from "react-router-dom";
import { Box } from "@mui/system";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";

export default function RespuestaRegistro() {
  const { currentAgentUser } = useAgentAuth();

   if (currentAgentUser) {
    return <Redirect to="/agentes/dashboard" />;
  } 

  return (
    <>
      <DashboardHeader isAgentSection={true} />
      <main
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          background: "#fff",
        }}
      >
        <Box>
          <img
            style={{ width: "180px", margin: "20px" }}
            src={cluppyImg}
            alt="imagen de cluppy de 'ok'"
          />
        </Box>
        <p style={{ fontSize: "18px" }}>
          ¡Gracias! Hemos registrado tu solicitud. <br />
          En 2 minutos recibirás un correo con los siguiente pasos.
          <br />
          <br />
          Agenda una entrevista para que podamos aprobar tu solicitud:
        </p>
        <Box
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 1,
            margin: "0px auto",
            fontSize: "18px",
            fontWeight: 600,
            width: "100%",
            maxWidth: "240px",
            borderRadius: "40px",
            backgroundColor: "#00BBEE",
            transition: "background-color 0.3s ease", // Añade una transición suave
            "&:hover": {
              backgroundColor: "#009ACC", // Cambia el color de fondo al hacer hover
            },
          }}
        >
          <ContactEmergencyIcon
            sx={{ marginRight: 1, color: "#fff" }}
            fontSize="large"
          />
          <a
            href={
              "https://calendar.app.google/uknE7JRxWNnxpDLD8"
            }
            target="_blank"
            rel="noreferrer"
            style={{ color: "#fff", textDecoration: "none" }}
          >
            Agendar entrevista
          </a>
        </Box>
      </main>
    </>
  );
}
